"use client"

import type { ReactNode, ComponentType, MouseEvent as ReactMouseEvent, CSSProperties } from "react"
import { cn } from "@/lib/utils"

export interface SidebarSubLinkProps {
  href: string
  children: ReactNode
  icon?: ReactNode
  LinkComponent?: ComponentType<any>
  linkProps?: Record<string, any>
  className?: string
  onClick?: (e: ReactMouseEvent<HTMLAnchorElement>) => void
  animationOrder?: number
  animationState?: 'entering' | 'leaving' | 'static'
  style?: CSSProperties
}

export function SidebarSubLink({
  href,
  children,
  icon,
  LinkComponent,
  linkProps = {},
  className,
  onClick,
  animationOrder,
  animationState,
  style,
}: SidebarSubLinkProps) {
  const Component = (LinkComponent || "a") as any

  const customStyle: CSSProperties = {
    ...style,
    ...(animationOrder !== undefined && { '--animation-order': animationOrder } as any),
  }

  return (
    <Component
      href={href}
      {...linkProps}
      onClick={onClick}
      className={cn(
        "sidebar-sublink flex items-center rounded-md px-3 py-1.5 text-sm transition-colors w-full text-left",
        "text-foreground hover:bg-secondary/70 hover:text-primary",
        className
      )}
      style={customStyle}
      data-state={animationState}
      data-animation-order={animationOrder}
    >
      {icon && <span className="mr-2 text-muted-foreground">{icon}</span>}
      <span>{children}</span>
    </Component>
  )
}

SidebarSubLink.displayName = "SidebarSubLink"
